import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Notifice Management Services
 * !== 알림 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/mypage/notihist`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/mypage/noti-hist`,
    nodes: [],
};

export const URLS = {
    ptli0308001q: `${BASE.path}/ptli0308001q`, // Notifice History List !==  알림 이력 목록 ==!
    ptli0308002q: `${BASE.path}/ptli0308002q`, // Notifice History Details !==  알림 이력 상세조회 ==!
};

export const APIS = {
    // Check Notifice History List !==  알림 이력 목록 조회 ==!
    getNotiHistList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Notifice Send History details inquiry !== 알림 발송 이력 상세 정보 조회 ==!
    getNotiHistInfo: (notiSendUuid: any) => {
        return api.get(`${BASE.api}/${notiSendUuid}`);
    },
};

export const SF_NOTI_HIST_SRCH: TFormSchema = {
    id: "form_notiHistSrch",
    schema: {
        notiNm: { type: "text", label: "L_NOTI_NM" },
        frstRgsrDtmRnge: {
            type: "daterange",
            label: "L_RCPN_DTM",
            start: { name: "sendStrtDt" },
            end: { name: "sendEndDt" },
            rangeButton: 0,
        },
    },
};

export const SG_NOTI_HIST_LIST: TGridSchema = {
    id: "grid_notiHistList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_NOTI_TP", binding: "notiTpValue", width: "10%" }] },
        { cells: [{ header: "L_NOTI_NM", binding: "notiNm", width: "*" }] },
        { cells: [{ header: "L_SEND_DTM", binding: "sendDtm", width: "15%" }] },
        { cells: [{ header: "L_RCPN_CFRM_YN", binding: "rcpnCfrmYn", width: "15%" }] },
        { cells: [{ header: "L_SNDR_NM", binding: "sndrNm", width: "10%" }] },
    ],
    body: [
        {
            cells: [{ binding: "notiTpValue" }],
        },
        {
            cells: [{ binding: "notiNm", align: "left" }],
        },
        {
            cells: [{ binding: "sendDtm" }],
        },
        {
            cells: [{ binding: "rcpnCfrmYn" }],
        },
        {
            cells: [{ binding: "sndrNm" }],
        },
    ],
};

export const SF_NOTI_HIST_INFO: TFormSchema = {
    id: "form_notiHistInfo",
    schema: {
        notiNm: { type: "text", label: "L_NOTI_NM", controlSize: 10 },
        notiMsgCn: { type: "textarea", label: "L_NOTI_MSG_CN", controlSize: 10, rows: 10 },
        notiTp: { type: "text", label: "L_NOTI_TP" },
        sendDtm: { type: "datetime", label: "L_SEND_DTM" },
        sndrNm: { type: "text", label: "L_SNDR_NM", controlSize: 10 },
        sndrEmlAddr: { type: "text", label: "L_SNDR_EML_ADDR" },
        sndrTelno: { type: "text", label: "L_SNDR_TELNO" },
    },
};

interface SettingsMap {
    [key: number]: string;
}

export const SETTINGS_MAP: SettingsMap = {
    1: "SMS",
    2: "E-Mail",
    4: "Push Notification", // 예시로 추가된 설정
    // 필요에 따라 여기에 더 많은 설정을 추가할 수 있습니다.
};
